var React = require('react');

function IntegrationsTriangleMobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M444.441 385.201L379.5 1.95029M444.441 385.201L230.056 208.231M444.441 385.201L-20.2422 159.05M379.5 1.95029L230.056 208.231M379.5 1.95029L-20.2422 159.05M230.056 208.231L-20.2422 159.05","stroke":"#3B284D"}));
}

IntegrationsTriangleMobile.defaultProps = {"width":"360","height":"393","viewBox":"0 0 360 393","fill":"none"};

module.exports = IntegrationsTriangleMobile;

IntegrationsTriangleMobile.default = IntegrationsTriangleMobile;
